import { IMPORT_TOOLS } from 'modules/importTool/importTool.constants';
import { NavigationTile, NavigationTileGrid } from 'modules/common/navigationTiles.component';
import { Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import React from 'react';

const useStyles = makeStyles(theme => ({
  root: {
    margin: theme.spacing(2),
  },
  title: {
    marginBottom: theme.spacing(2),
  },
}));

const ImportToolMenu = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Typography className={classes.title} variant="h4">
        Select an Import Tool
      </Typography>
      <NavigationTileGrid>
        {IMPORT_TOOLS.map(tool => (
          <NavigationTile key={tool.route} icon={tool.icon} title={tool.title} description={tool.description} to={tool.route} />
        ))}
      </NavigationTileGrid>
    </div>
  );
};

export default ImportToolMenu;
